import type { I18nDefinition } from '@backmarket/nuxt-module-i18n/types'

export default {
  aboutBatteryHealth: {
    id: 'product_jp_about_battery_health',
    defaultMessage: 'About battery health',
  },
  capacityGuaranteedContent: {
    id: 'product_jp_capacity_guaranteed_content',
    defaultMessage:
      'With 80% battery capacity, you can stream videos for up to around 16.5 hours.',
  },
  capacityGuaranteedHeading: {
    id: 'product_jp_capacity_guaranteed_heading',
    defaultMessage: '80–100% capacity guaranteed',
  },
  learnMore: {
    id: 'product_jp_learn_more',
    defaultMessage: 'Learn more',
  },
  newBatteryContent: {
    id: 'product_jp_new_battery_content',
    defaultMessage: 'Brand new battery option available for selected models.',
  },
  newBatteryHeading: {
    id: 'product_jp_new_battery_heading',
    defaultMessage: 'New battery option',
  },
  productFeature: {
    id: 'product_jp_product_feature',
    defaultMessage: 'Product feature',
  },
  testedVerifiedContent: {
    id: 'product_jp_tested_verified_content',
    defaultMessage:
      'Fully tested and inspected by experts to ensure 100% functionality.',
  },
  testedVerifiedHeading: {
    id: 'product_jp_tested_verified_heading',
    defaultMessage: 'Tested and verified',
  },
} as Record<string, I18nDefinition>
